module.exports = __webpack_public_path__ + "static/media/Liwia uses telemedicine software for digital primary care.34eec4b1.webp";